import type { JSX } from 'react';

export type FactCategory = 'frameworks' | 'interests' | 'languages' | 'tools';

export type Fact = {
    category: FactCategory;
    items: string[];
};

export type ProjectType = 'dev' | 'art';

export type Project = {
    title: string;
    url?: string;
    urlTitle?: string;
    description?: JSX.Element | string;
};

export interface DevProject extends Project {
    source?: string;
    preview: string;
    skills: string[];
}

export enum Medium {
    Digital = 'digital',
    PenSharpie = 'pen, sharpie',
    PencilSharpie = 'pencil, sharpie',
    Sharpie = 'sharpie',
}

export interface ArtProject extends Project {
    url: string;
    medium: Medium;
    tools: string;
    timestamp: Date;
}
